import { Global, MantineProvider } from '@mantine/core';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { global, theme } from 'theme';

type Props = {
  children: ReactNode;
};

export const StylesProvider = ({ children }: Props) => {
  const { i18n } = useTranslation();

  return (
    <MantineProvider
      theme={{ ...theme, datesLocale: i18n.language }}
      withGlobalStyles
      withNormalizeCSS
    >
      <Global styles={global} />
      {children}
    </MantineProvider>
  );
};
